import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "./default.style.css";
import "./login.style.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { BiometriaLogin } from "./Pages/login/index.jsx";
import { Providers } from "./Contexts/index.jsx";
import { BiometriaInfo } from "./Pages/info/index.jsx";
import { BiometriaCancelar } from "./Pages/cancelar/index.jsx";
import { BiometriaGeolocalizacao } from "./Pages/geolocalizacao/index.jsx";
import { BiometriaTermos } from "./Pages/termos/index.jsx";
import { BiometriaInstrucoes } from "./Pages/instrucoes/index.jsx";
import { BiometriaCaptura } from "./Pages/captura/index.jsx";
import { RedirectLink } from "./Pages/redirect/index.jsx";
import { NotFound } from "./Pages/not-found/index.jsx";

export default function App() {
  return (
    <Providers>
      <Router>
        <Routes>
          <Route path="/t/:hash" element={<RedirectLink />} />

          <Route
            exact
            path="/termosconsentimentomotorista/:hash"
            element={<BiometriaLogin />}
          />

          <Route exact path="/biometria/info" element={<BiometriaInfo />} />
          <Route
            exact
            path="/biometria/geolocalizacao"
            element={<BiometriaGeolocalizacao />}
          />
          <Route exact path="/biometria/termos" element={<BiometriaTermos />} />
          <Route
            exact
            path="/biometria/instrucoes"
            element={<BiometriaInstrucoes />}
          />

          <Route
            exact
            path="/biometria/captura"
            element={<BiometriaCaptura />}
          />

          <Route
            exact
            path="/biometria/cancelar"
            element={<BiometriaCancelar />}
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Providers>
  );
}
